module.exports = __webpack_public_path__ + "static/media/chapada-dos-guimaraes-mt.3f3646d7.jpg";